import script from "./ExportPDF.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExportPDF.vue?vue&type=script&lang=ts&setup=true"

import "./ExportPDF.vue?vue&type=style&index=0&id=527855fb&lang=scss&scoped=true"

import exportComponent from "C:\\work\\to-create\\bailing\\yc-bailing-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-527855fb"]])

export default __exports__